import { createContext, useContext, useEffect, useRef, useState, useCallback } from "react";
import { panelApi, getToken, setToken, clearToken, apiError } from "@/panel/panelApi";

const AuthContext = createContext(null);

const hasLoginToken = () =>
  typeof window !== "undefined" && window.location.hash.includes("token=");

export function PanelAuthProvider({ children }) {
  // user: null = checking, false = not authed, object = authed
  const [user, setUser] = useState(getToken() || hasLoginToken() ? null : false);
  const [googleError, setGoogleError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    // Custom Google OAuth callback: backend redirects here with the minted JWT in the URL fragment.
    if (hasLoginToken()) {
      const tok = new URLSearchParams(window.location.hash.slice(1)).get("token");
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
      if (tok) {
        setToken(tok);
        panelApi
          .get("/auth/me")
          .then(({ data }) => setUser(data))
          .catch(() => {
            clearToken();
            setGoogleError("Η σύνδεση Google απέτυχε.");
            setUser(false);
          });
        return;
      }
    }

    if (!getToken()) return;
    panelApi
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {
        clearToken();
        setUser(false);
      });
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, logout, googleError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const usePanelAuth = () => useContext(AuthContext);
